<template>
  <div id="app">
    <div id="modal"/>
    <!-- <div id="corp-config-modal"/>
    <div id="register-config-modal"/>
    <div id="estimate-config-modal"/>
    <div id="nesting-config-modal"/>
    <div id="system-config-modal"/>
    <div id="cost-custom-config-modal"/>
    <div id="user-manage-modal"/>
    <div id="add-user-modal"/>
    <div id="bom-custom-config-modal"/>
    <div id="support-modal"/>
    <div id="editing-file-modal"/>
    <div id="editing-modal"/> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style src="./css/reset.scss" lang="scss"></style>
<style src="./css/style.scss" lang="scss"></style>
<style>
html, body {
  height: 100%;
  padding-top: constant(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-left: constant(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);

  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/main/js/App.vue